import { Field} from 'formik';
import { Radio,  Stack, FormControl, Image,Box  } from '@chakra-ui/react';
import ElementInstructions from '../../formElements/components/ElementInstructions';
import ElementHeading from '../../formElements/components/ElementHeading';
import ElementErrorMessage from '../../formElements/components/ElementErrorMessage';
import {  handleRadioButtonChange } from '../../formElements/utils';
import InputWrapper from '../../formElements/components/InputWrapper';
import { getResumeOrSectionIndex } from '../../handlers';
import { formatOptionLabel } from '../../handlers/utils';

const ParserRadio = ({ fieldName, qObj, props, styles }) => {
  const img_urls = qObj.option_images;
  const index = getResumeOrSectionIndex(props.stateProps, props.formikProps);
  const orientation =
    typeof qObj.orientation === 'undefined' ? 'row' : qObj.orientation;
  const resumeIndex = props.stateProps.sectionData.resumeIndex;
  //const savedValue = props.stateProps.dataToSave.saved.resumes[resumeIndex].parser[0].P1;

  const parser = props.stateProps.dataToSave.saved.resumes[resumeIndex].parser;
  const savedValue = typeof parser === 'undefined' ? 'no' :parser[0].P1;

/*
  if (typeof props.formikProps.values.jobSeekerData[resumeIndex][qObj.qid] === 'undefined') {
    props.formikProps.values.jobSeekerData[resumeIndex][qObj.qid] = qObj.options[0].value;
  }
  */
  return (
    <Field name={fieldName}>
      {({ field, form }) => {
        if(qObj.qid==='P1' && savedValue === 'yes') {
          return null;
        } else {
          return (
            <Box id={qObj.qid}>
              <FormControl
                isInvalid={form.errors[qObj.id] && form.touched[qObj.id]}
              >
                <ElementHeading qObj={qObj} props={props} />
                <ElementInstructions instructions={qObj.instructions} />
                <InputWrapper>
                  <Stack direction={orientation}>
                    {qObj.options.map((option, option_index) => {
                      return (
                        <Radio
                          sx={{ ...styles.radio }}
                          name={fieldName}
                          {...field}
                          key={option.label}
                          value={option.value}
                          onChange={e =>
                            handleRadioButtonChange(
                              props.formikProps,
                              props.stateProps,
                              index,
                              qObj,
                              e.currentTarget.value
                            )
                          }
                        >
                          {typeof img_urls !== 'undefined' && (
                            <Image src={img_urls[option_index]} />
                          )}
                          {formatOptionLabel(option.value, option.label)}
                        </Radio>
                      );
                    })}
                  </Stack>
                </InputWrapper>
                <ElementErrorMessage form={form} index={qObj.index} qid={qObj.qid} />
              </FormControl>
            </Box>
          );
        }
      }}
    </Field>
  );
};

export default ParserRadio;
